module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/assessment_achievements/5_981f599623eeb39e05c678a5a6f03c50.png";